import moment from "moment-timezone"
export default {
    methods: {
        getFormatedDate(rawDate:string){
            const formatedDate = moment(rawDate).format("DD/MM/YYYY")
            return formatedDate
        },
        getFormatedHour(rawDate:string){
            const time = moment(rawDate).tz("America/Bahia").format("hh:mm")
            return time
        }
    }
}